// ***** Record Set Data Model to use in MVC code for displaying records and associated options and tools *****

// Initialize namespaces
if (typeof TGN == 'undefined') { var TGN = {}; }
if (typeof TGN.Ancestry == 'undefined') { TGN.Ancestry = {}; }
if (typeof TGN.Ancestry.Search == 'undefined') { TGN.Ancestry.Search = {}; }
if (typeof TGN.Ancestry.Search.RSDM == 'undefined') { TGN.Ancestry.Search.RSDM = {}; }

TGN.Ancestry.Search.RSDM.RecordSetDataModel =
{
   // Member variables
   'ImageId': null,
   'Dbid': null,
   'UserId': null,
   'SelectedPid': null,
   'DoOremPid': false,
   'DoOremImgAll': false,
   'OremImgAllCalled': false,
   'DoShoeboxUser': false,
   'DoTreeUser': false,
   'DoUsernamesAll': false,
   'DoMessageBoardsAll': false,
   'DoLinkedRecords': false,
   'Records': {},
   'Users': {},
   'UserProfileNum': 0,
   'UsePUB': false,
   'UseOldPUB': false,
   'TreeId': null,
   'PersonId': null,
   'PubParams': null,

   // Initialization
   'Init': function (initObj) {
      this.Dbid = ('undefined' != typeof initObj.dbid ? initObj.dbid : "NO_DBID_ERROR");
      this.ImageId = ('undefined' != typeof initObj.imageid ? initObj.imageid : "NO_IMAGE_ID_ERROR");
      this.UserId = ('undefined' != typeof initObj.userId ? initObj.userId : "NO_USER_ID_ERROR");
      this.ClientId = 'AncestrySearch';
      this.DoOremPid = ('undefined' != typeof initObj.doOremPid ? initObj.doOremPid : false);
      this.DoOremImgAll = ('undefined' != typeof initObj.doOremImgAll ? initObj.doOremImgAll : false);
      this.DoShoeboxUser = ('undefined' != typeof initObj.doShoeboxUser ? initObj.doShoeboxUser : false);
      this.DoTreesUser = ('undefined' != typeof initObj.doTreesUser ? initObj.doTreesUser : false);
      this.DoUsernamesAll = ('undefined' != typeof initObj.doUsernamesAll ? initObj.doUsernamesAll : false);
      this.DoMessageBoardsAll = ('undefined' != typeof initObj.doMessageBoardsAll ? initObj.doMessageBoardsAll : false);
      this.DoLinkedRecords = ('undefined' != typeof initObj.doLinkedRecords ? initObj.doLinkedRecords : false);
      this.UsePUB = (typeof initObj.usePUB != 'undefined' ? initObj.usePUB : false);
      this.UseOldPUB = (typeof initObj.useOldPUB != 'undefined' ? initObj.useOldPUB : false);
      this.TreeId = (typeof initObj.treeId != 'undefined' ? initObj.treeId : "");
      this.PersonId = (typeof initObj.personId != 'undefined' ? initObj.personId : "");
      this.PubParams = (typeof initObj.pubParams != 'undefined' && initObj.PubParams != "" ? "&" + initObj.pubParams : "");

      //Get this users profile info from cookie.
      var userCookie = getCookie("VARSESSION");
      var subCookies = userCookie.split("&");
      for (var i = 0; i < subCookies.length; i++) {
         if (subCookies[i].indexOf("ULINK") == 0) {
            var ulinks = subCookies[i].split(",");
            var UserObj = {};
            if (ulinks.length >= 4) {
               if (ulinks[0].length > 6) {
                  UserObj.DisplayName = ulinks[0].substring(6); //This one has ulink= start
               }
               UserObj.PhotoId = ulinks[1];
               UserObj.MacId = ulinks[2];
               UserObj.UserId = ulinks[3];
               this.Users[UserObj.UserId] = UserObj;
               break;
            }
         }
      }
   },
   // Event Registration
   'Registrants': {},
   //callback is the function, callbackfuncName is the name of that function so we can report the failure more accurately.
   'Register': function (eventName, callback, callbackfuncName) {
      if (typeof this.Registrants[eventName] == 'undefined')
         this.Registrants[eventName] = new Array();
      if (typeof callbackfuncName != 'undefined') {
         callback.funcName = callbackfuncName; //added for reporting errors in CallRegistrants
      }
      this.Registrants[eventName][this.Registrants[eventName].length] = callback;
   },
   'CallRegistrants': function (eventName, pid, obj) {
      if (typeof this.Registrants[eventName] == 'undefined')
         return;
      var regArray = this.Registrants[eventName];
      var i = 0;
      for (i = 0; i < regArray.length; i++) {
         try {
            regArray[i](eventName, pid, obj);
         }
         catch (err) {
            var errMsg = "CallRegistrants- EvntName:" + eventName + ", idx:" + i;
            if (typeof regArray[i].funcName != 'undefined') {
               errMsg += " CallbackHandle: " + regArray[i].funcName;
            }
            $Anc.PublishException("RSDM", errMsg, err, "RecordSetDataModel.js");
         }
      }
   },

   'GetUserLinkObj': function (ucdmid, displayName, id, photoId, macId, showAvatar, docUrl, contextType, contextValue) {
      this.ucdmid = ucdmid;
      this.displayName = displayName;
      this.id = "" + id;
      this.photoId = photoId;
      this.macId = macId;
      this.showAvatar = showAvatar;
      this.userDocDomain = docUrl;
      this.contextType = contextType;
      this.contextValue = contextValue;
   },

   'GetUserProfile': function (userId, showAvatar, contextType, contextValue) {
      var theUser = this.Users[userId];
      var uniqueNum = this.UserProfileNum++;

      if (theUser == null) {
         if (typeof this.badUserIds == 'undefined') {
            this.badUserIds = {};
         }
         if (typeof this.badUserIds[userId] == 'undefined') {
            this.badUserIds[userId] = "";
         }
         return "";
      }
      return TGN.Ancestry.Community.MiniProfile.GetUserLink(new this.GetUserLinkObj(userId, theUser.DisplayName, uniqueNum, theUser.PhotoId, theUser.MacId, showAvatar, "//" + userDocDomain, contextType, contextValue));
   },

   // Primary Actions Triggering Events
   'SetSelectedPid': function (pid, snamegpids) {
      if (pid == this.SelectedPid) {
         return;
      }
      this.SelectedPid = pid;
      this.CallRegistrants('SelectedPidChangedImmediate', this.SelectedPid, this);

      var ajaxOps = "";
      var recordObj = this.Records['_' + pid];
      if (this.DoOremImgAll && !this.OremImgAllCalled) // in this one instance we don't check for an empty object; we rely on the flag instead
      {
         ajaxOps += "oremimgall";
         this.OremImgAllCalled = true;
      }
      if (this.DoOremPid && (typeof recordObj == 'undefined' || recordObj.Orems == null)) {
         ajaxOps += (ajaxOps.length > 0 ? "-" : "") + "orempid";
      }
      if (this.DoShoeboxUser && (typeof recordObj == 'undefined' || recordObj.Shoeboxes == null))
         ajaxOps += (ajaxOps.length > 0 ? "-" : "") + "sbuser";
      if (this.DoTreesUser && (typeof recordObj == 'undefined' || recordObj.Trees == null))
         ajaxOps += (ajaxOps.length > 0 ? "-" : "") + "ptuser";
      if (this.DoLinkedRecords && (typeof recordObj == 'undefined' || recordObj.LinkedRecords == null))
         ajaxOps += (ajaxOps.length > 0 ? "-" : "") + "linkedrecordsall";
      if (this.DoMessageBoardsAll && (typeof recordObj == 'undefined' || recordObj.MessageBoards == null))
         ajaxOps += (ajaxOps.length > 0 ? "-" : "") + "messageboardsall";
      if (this.DoUsernamesAll && ajaxOps.length > 0) // this is just passed through, but only if we are querying for another value
         ajaxOps += "-usernamesall";

      if (ajaxOps.length > 0) {
         // Get all the info related to this PID from the various services
          var unique = new Date();
          $.ajax({
            dataType:"json",
            url: "/content/pages/ajax/RecordSetDataModelAJAXHandler.ashx?dbid=" + this.Dbid +
                "&pid=" + this.SelectedPid +
                "&iid=" + this.ImageId +
                "&unq=" + unique.getTime() +
                "&op=" + ajaxOps + 
                "&snamegpids=" + (snamegpids == null ? "" : snamegpids) +
                "&treeId=" + this.TreeId +
                "&personId=" + this.PersonId +
                "&usePUB=" + this.UsePUB +
                "&useOldPUB=" + this.UseOldPUB +
                "&client=" + this.ClientId +
                this.PubParams,
            success: function (data) {
                TGN.Ancestry.Search.RSDM.RecordSetDataModel.ProcessSetSelectedPidAJAXResponse(data);
                if (typeof OremInitData != "undefined") {
                    OremInitData = data;
                    //Update link for corrections to show proper label (if corrections have previously been made)
                    OremMetaData.CreateCorrectionContributionsContent(null, true);
                }
            }
          })
      }
      else {
         // Notify the views of the selected pid change
         this.CallRegistrants('SelectedPidChanged', this.SelectedPid, this);
      }
   },
   'AddOremChange': function (pid, oremChangeList) {
      //oremChangeList is an array of OremChangeObjects
      var recordL = this.Records['_' + pid];
      var oremL = null;
      if (typeof recordL == 'undefined') {
         this.Records['_' + pid] = {};
      }
      else {
         oremL = recordL.Orems;
      }

      if (oremL == null) {
         oremL = oremChangeList;
         this.Records['_' + pid].Orems = oremL;
      }
      else {
         for (var i = 0; i < oremChangeList.length; i++) {
            oremL.push(oremChangeList[i]);
         }
      }
      this.CallRegistrants('OremChanged', pid, this);
   },
   'RemoveOremChange': function (pid, itemId) {

      var oremL = this.Records['_' + pid].Orems;
      var newOremArray = [];
      var oremRemoved = null;
      if (oremL != null) {
         for (var i = 0; i < oremL.length; i++) {
            if (oremL[i].ItemId != itemId) {
               newOremArray.push(oremL[i]);
            }
            else {
               oremRemoved = oremL[i];
            }
         }
      }
      this.Records['_' + pid].Orems = newOremArray;


      this.CallRegistrants('OremRemoved', this.SelectedPid, oremRemoved);
      this.CallRegistrants('OremChanged', this.SelectedPid, this);
   },
   'RemoveOremEntry': function (pid, entryId) {
      var oremL = this.Records['_' + pid].Orems;
      var newOremArray = [];
      var oremRemoved = [];
      if (oremL != null) {
         for (var i = 0; i < oremL.length; i++) {
            if (oremL[i].EntryId != entryId) {
               newOremArray.push(oremL[i]);
            }
            else {
               oremRemoved.push(oremL[i]);
            }
         }
      }
      this.Records['_' + pid].Orems = newOremArray;


      this.CallRegistrants('OremRemoved', this.SelectedPid, oremRemoved);
      this.CallRegistrants('OremChanged', this.SelectedPid, this);
   },
   'SaveRecordToShoebox': function (pid, shoeboxSave) {
      this.AddUserRecordAction(pid, shoeboxSave, 'Shoeboxes');
      this.CallRegistrants('SaveRecordToShoebox', pid, this);
   },
   'RemoveRecordFromShoebox': function (pid, shoeboxSave) {
      this.RemoveUserRecordAction(pid, shoeboxSave.UserId, 'Shoeboxes');
      this.CallRegistrants('RemoveRecordFromShoebox', pid, this);
   },
   'SaveRecordToTree': function (pid, treeSave) {

   },
   'RemoveRecordFromTree': function (pid, treeSave) {
      this.RemoveUserRecordAction(pid, treeSave.UserId, 'Trees', 'PersonId', treeSave.PersonId);
      this.CallRegistrants('RemoveRecordFromTree', pid, this);
   },
   'AddComment': function (pid, comment) {
      var commL = this.Records['_' + pid].Comments;
      if (commL == null) {
         commL = this.Records['_' + pid].Comments = [];
      }
      commL.push(comment);

      this.CallRegistrants('CommentAdded', this.SelectedPid, comment);
      this.CallRegistrants('CommentsChanged', this.SelectedPid, this);
   },
   'RemoveComment': function (pid, commentId) {
      var commentL = this.Records['_' + pid].Comments;
      var newCommentArray = [];
      if (commentL != null) {
         for (var i = 0; i < commentL.length; i++) {
            if (commentL[i].EntryId != commentId) {
               newCommentArray.push(commentL[i]);
            }
         }
      }
      this.Records['_' + pid].Comments = newCommentArray;
      this.CallRegistrants('CommentRemoved', this.SelectedPid, commentId);
      this.CallRegistrants('CommentsChanged', this.SelectedPid, this);
   },

   // Utility Stuff, including AJAX callbacks
   'USERNAME_NA': "Not_Available", // means we tried to get a username, but couldn't for some reason

   'ProcessSetSelectedPidAJAXResponse': function (data) {
      try {
          ajaxResult = data;
         // This regular expression validator is useful to prevent bad JSON code from being executed and is suggested here: http://tools.ietf.org/html/rfc4627
         // Update the model with the AJAX info
         var i;
         var rsdm = TGN.Ancestry.Search.RSDM.RecordSetDataModel;
         var ajaxRecordObj;
         var recordObj;
         if (ajaxResult.PidList.length > 0) {

            for (i = 0; i < ajaxResult.PidList.length; i++) {
               var curPid = ajaxResult.PidList[i];
               ajaxRecordObj = ajaxResult.Records['_' + curPid];
               recordObj = rsdm.Records['_' + curPid];
               if (typeof recordObj == 'undefined') {
                  rsdm.Records['_' + curPid] = ajaxRecordObj;
               }
               else {
                  if (ajaxRecordObj.Orems != null)
                     recordObj.Orems = ajaxRecordObj.Orems;
                  if (ajaxRecordObj.Comments != null)
                     recordObj.Comments = ajaxRecordObj.Comments;
                  if (ajaxRecordObj.Shoeboxes != null)
                     recordObj.Shoeboxes = ajaxRecordObj.Shoeboxes;
                  if (ajaxRecordObj.Trees != null)
                     recordObj.Trees = ajaxRecordObj.Trees;
                  if (ajaxRecordObj.SavedToPublicTrees != null)
                     recordObj.SavedToPublicTrees = ajaxRecordObj.SavedToPublicTrees;
                  if (ajaxRecordObj.OtherRecords != null)
                     recordObj.OtherRecords = ajaxRecordObj.OtherRecords;
                  if (ajaxRecordObj.SavedToPrivateTrees != null)
                     recordObj.SavedToPrivateTrees = ajaxRecordObj.SavedToPrivateTrees;
                  if (ajaxRecordObj.SavedToShoeBoxPeople != null)
                     recordObj.SavedToShoeBoxPeople = ajaxRecordObj.SavedToShoeBoxPeople;
                  if (ajaxRecordObj.MessageBoards != null)
                     recordObj.MessageBoards = ajaxRecordObj.MessageBoards;
               }
            }
         }
         if (typeof ajaxResult.Users != 'undefined') {
            for (var userGuid in ajaxResult.Users) {
               var curUser = ajaxResult.Users[userGuid];
               rsdm.Users[curUser.UserId] = curUser;
            }
         }
         // Notify the views of the model changes
         rsdm.CallRegistrants('SelectedPidChanged', rsdm.SelectedPid, rsdm);
      }
      catch (err) {
         $Anc.PublishException("ContentViewer", "ProcessSetSelectedPidAJAXResponse", err.description, "RecordSetDataModel.js");
      }
   },

   "DoesUserRecordActionExist": function (pid, userId, actionLocation) {
      if (typeof this.Records == 'undefined')
         return false;
      if (typeof this.Records['_' + pid] == 'undefined')
         return false;
      if (this.Records['_' + pid][actionLocation] == null)
         return false;
      for (var i = 0; i < this.Records['_' + pid][actionLocation].length; i++) {
         if (this.Records['_' + pid][actionLocation][i] != null && this.Records['_' + pid][actionLocation][i].UserId == userId)
            return true;
      }
      return false;
   },

   "RemoveUserRecordAction": function (pid, userId, actionLocation, keyName, keyValue) {
      if (!this.DoesUserRecordActionExist(pid, userId, actionLocation))
         return;
      for (var i = 0; i < this.Records['_' + pid][actionLocation].length; i++) {
         if (this.Records['_' + pid][actionLocation][i] != null && this.Records['_' + pid][actionLocation][i].UserId == this.UserId) {
            if (keyName && keyName != null && keyName.length > 0) {
               if (this.Records['_' + pid][actionLocation][i][keyName] == keyValue) {
                  this.Records['_' + pid][actionLocation][i] = null;
                  break;
               }
            }
            else {
               this.Records['_' + pid][actionLocation][i] = null;
               break;
            }
         }
      }
   },

   "AddUserRecordAction": function (pid, actionObj, actionLocation) {
      if (typeof this.Records == 'undefined')
         this.Records = {};
      if (typeof this.Records['_' + pid] == 'undefined')
         this.Records['_' + pid] = {};
      if (typeof this.Records['_' + pid][actionLocation] == 'undefined' || this.Records['_' + pid][actionLocation] == null)
         this.Records['_' + pid][actionLocation] = [];
      this.Records['_' + pid][actionLocation][this.Records['_' + pid][actionLocation].length] = actionObj;
   },
   "GetOrems": function (pid) {
      if (typeof pid == 'undefined') {
         pid = this.SelectedPid;
      }
      var returnA = null;
      //TODO do logic to load orems if not already loaded		
      if (this.DoOremPid || this.DoOremImgAll) {
         if (typeof this.Records == 'undefined') {
            return null;
         }
         else if (typeof this.Records['_' + pid] != 'undefined') {
            returnA = this.Records['_' + pid].Orems;
         }
      }

      if (null == returnA) {
         returnA = [];
      }

      return returnA;
   },
   "GetComments": function (pid) {
      if (typeof pid == 'undefined') {
         pid = this.SelectedPid;
      }
      var returnA = null;
      if (this.DoOremPid || this.DoOremImgAll) {
         if (typeof this.Records == 'undefined') {
            return null;
         }
         else if (typeof this.Records['_' + pid] != 'undefined') {
            returnA = this.Records['_' + pid].Comments;
         }
      }

      return returnA;
   }
};

